import { Routes } from '@angular/router';
import { BbitAuthGuard, bbitWebsiteAuthRoutes } from '@bbitgmbh/website.sdk';
import { AccountComponent } from './account/account.component';
import { KnowHowFilesComponent } from './account/know-how-files/know-how-files.component';
import { PlaceBookingsComponent } from './account/place-bookings/place-bookings.component';
import { ProfileComponent } from './account/profile/profile.component';
import { BookingComponent } from './booking/booking/booking.component';
import { BookingSelectionComponent } from './booking/booking-selection/booking-selection.component';
import { ImprintComponent } from './imprint/imprint.component';
import { LegalComponent } from './legal/legal.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CompanionsComponent } from './account/companions/companions.component';
import { TvComponent } from './tv/tv.component';

export const appRoutes: Routes = [
  ...bbitWebsiteAuthRoutes,
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [BbitAuthGuard],
    children: [
      { path: 'profile', component: ProfileComponent },
      { path: 'place-bookings', component: PlaceBookingsComponent },
      // { path: 'documents/:_bucket', component: DocumentsComponent },
      // { path: 'document/:_bucket/:_id', component: DocumentComponent },
      { path: 'companions', component: CompanionsComponent },
      { path: 'know-how-files', component: KnowHowFilesComponent },
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
    ],
  },
  { path: 'imprint', component: ImprintComponent },
  { path: 'legal', component: LegalComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'places', component: BookingSelectionComponent },
  { path: 'places/book', component: BookingComponent, canActivate: [BbitAuthGuard] },
  {
    path: 'tv',
    component: TvComponent,
  },
  { path: '', redirectTo: '/places', pathMatch: 'full' },
  { path: '**', redirectTo: '/places', pathMatch: 'full' },

  // { path: '**', component: TempUpdatingComponent },
];
